export default __webpack_public_path__ + "static/media/ClearKeyLogoWhite.996b219f.svg";